import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
	Col,
	Row,
	Card,
	Button,
	CardBody,
	CardTitle,
	CardHeader,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
} from "reactstrap";
import { showApiError } from "utils/errorRoutingUtils";
import {
	failAlert,
	retrieveFailAlert,
	twoOptionsAlert,
} from "utils/alertUtils";
import { useFromUser } from "stores/LocalStorageHelper";
import useCurrentDealStore from "stores/DealStore";
import dayjs from "dayjs";
import shallow from "zustand/shallow";
import fairfaxlogo from "assets/img/fairfaxsoftware-logo.png";
import { getFairfax, submitFairfax_v2 } from "api/FairFaxAPI";
import { saveVehicle } from "api/InventoryAPI";
import DLRdmv from "../../../../crm/helperFunctions/DLRdmv";
import DMVdesk from "../../../../crm/helperFunctions/DMVdesk";
import VerifinyX from "../../../../crm/helperFunctions/VerifinyX";
import ChildrenModal from "../../../../../components/modals/ChildrenModal";
import useCurrentSaleStore from "../../../../../stores/SaleStore";
const FairFaxTab = () => {
	const { ID, license, editVehicle, vehicle, coBuyerRecNum } =
		useCurrentDealStore(
			(state) => ({
				ID: state.deal.ID,
				license: state?.vehicle?.license,
				editVehicle: state.editVehicle,
				vehicle: state.vehicle,
				coBuyerRecNum: state.deal?.coBuyerRecNum,
			}),
			shallow
		);
	const { saleType } = useCurrentSaleStore((state) => state, shallow);
	const [ros, setRos] = useState("");
	const [tag, setTag] = useState("");
	const [rosNumber, setRosNumber] = useState("");
	const [tlpNumber, setTlpNumber] = useState("");
	const [expirationDate, setExpirationDate] = useState("");
	const locationID = useFromUser("locationID");
	const [optionsModal, setOptionsModal] = useState(false);
	const [formData, setFormData] = useState({
		locationID: locationID,
		dealID: ID,
		isAnd: false,
		buyersDealerNumber: "",
		buyersPermitNumber: "",
	});

	const regOptions = [
		{ value: "REG 397", label: "REG 397 - New Vehicle ROS" },
		{ value: "REG 51", label: "REG 51 - Used Vehicle ROS" },
		{ value: "REG 396", label: "REG 396 - Wholesale ROS" },
		{ value: "REG 398", label: "REG 398 - Auction ROS" },
	];

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
	};

	const toggleOptions = () => {
		setOptionsModal(!optionsModal);
	};

	const handleContinue = (ROS) => {
		const inventoryID = vehicle?.inventoryID;
		if (inventoryID) {
			const updatedVehicle = { ...vehicle, reportOfSale: ROS };
			const request = {
				vehicle: updatedVehicle,
				kbb: { dcTableKbb: null },
			};
			saveVehicle(request).then(
				(res) => {
					editVehicle(res.data.content.vehicle);
				},
				(err) => {
					if (!err.isGeneralError) {
						showApiError(err, retrieveFailAlert);
					}
				}
			);
		}
	};

	const commitData = () => {
		if (ID > 0) {
			getFairfax(ID).then(
				(response) => {
					const data = response.data.content;
					setRos(data?.ros || "");
					setTag(data?.tag || "");
					setRosNumber(data?.rosNumber || "");
					setTlpNumber(data?.tlpNumber || "");
					setExpirationDate(data?.expirationDate || "");
				},
				(error) => console.log(error)
			);
		}
	};

	useEffect(() => {
		commitData();
		// eslint-disable-next-line
	}, [ID]);

	const openInNewTab = (url) => {
		if (url) {
			const newWindow = window.open(url, "_blank", "noopener,noreferrer");
			if (newWindow) newWindow.opener = null;
		}
	};

	const submitData = () => {
		twoOptionsAlert("Do you want to Submit a new request?", "Yes", "No").then(
			(res) => {
				if (res === "Yes") {
					let body = { ...formData };
					body.dealID = ID;
					body.locationID = locationID;
					submitFairfax_v2(body).then(
						(response) => {
							openInNewTab(response.data.content.ros);
							openInNewTab(response.data.content.tag);
							commitData();
							handleContinue(response.data.content.rosNumber);
							toggleOptions();
						},
						(err) => {
							failAlert(err.response.data.message);
							toggleOptions();
						}
					);
				}
			}
		);
	};
	const QuickTagsOnline = () => (
		<>
			<hr className="my-3 noDesktop text-center" />
			<a
				className="btn-primary mb-2  btn btn-lg"
				href={"https://ca.quickcartag.com/"}
				target="_blank"
				rel="noopener noreferrer"
			>
				<i className="nc-icon nc-cloud-upload-94" /> Quick Tags Online
			</a>
		</>
	);

	return (
		<Col>
			<CardHeader>
				<CardTitle tag="h3">
					<img alt="Fairfax Logo" className="lenderImg" src={fairfaxlogo} />
				</CardTitle>
				<Row>
					<Col className="text-center">
						<QuickTagsOnline />
						<Button
							size="lg"
							type="submit"
							onClick={toggleOptions}
							className="btn-primary mb-2 text-center"
						>
							<i className="nc-icon nc-cloud-upload-94" /> Submit Application
						</Button>
					</Col>
				</Row>
			</CardHeader>
			{ros && tag && rosNumber && tlpNumber && expirationDate && (
				<>
					<Row className="mb-2">
						<div className="col-6 px-0">
							<Button
								size="lg"
								color="primary"
								onClick={() => openInNewTab(ros)}
							>
								<i className="nc-icon nc-paper" /> ROS Form
							</Button>
						</div>
						<div className="col-6 px-0">
							<Button
								size="lg"
								color="primary"
								className="pull-right"
								onClick={() => openInNewTab(tag)}
							>
								<i className="nc-icon nc-paper" /> Tag Form
							</Button>
						</div>
					</Row>
					<Card>
						<CardHeader>
							<CardTitle tag="h3">
								<img
									alt="Fairfax Logo"
									className="lenderImg"
									src={fairfaxlogo}
								/>
							</CardTitle>
						</CardHeader>
						<CardBody>
							<Row>
								<Col md="3" className="text-center">
									<h6>License Plate</h6>
									{license}
								</Col>
								<Col md="3" className="text-center">
									<h6>ROS Number</h6>
									{rosNumber}
								</Col>
								<Col md="3" className="text-center">
									<h6>TLP Number</h6>
									{tlpNumber}
								</Col>
								<Col md="3" className="text-center">
									<h6>Expiration Date</h6>
									{expirationDate
										? dayjs(expirationDate).format("MM/DD/YYYY")
										: ""}
								</Col>
							</Row>
						</CardBody>
					</Card>
				</>
			)}
			<ChildrenModal
				modal={optionsModal}
				toggle={toggleOptions}
				modalTitle={"ROS Application"}
				size="lg"
			>
				<Form>
					{saleType === 1 && (
						<>
							<FormGroup row>
								<Label for="buyersDealerNumber" sm={4}>
									Buyer's Dealer #
								</Label>
								<Col sm={8}>
									<Input
										type="text"
										name="buyersDealerNumber"
										value={formData.buyersDealerNumber}
										onChange={handleChange}
									/>
								</Col>
								<FormText color="danger">
									A Statement of Facts is required when selecting an out of
									state buyer dealer. By clicking Submit, you are confirming a
									completed Statement of Facts will be retained in the
									dealership records for this sale.
								</FormText>
							</FormGroup>
							<FormGroup row>
								<Label for="buyersPermitNumber" sm={4}>
									Buyer's Permit #
								</Label>
								<Col sm={8}>
									<Input
										type="text"
										name="buyersPermitNumber"
										value={formData.buyersPermitNumber}
										onChange={handleChange}
									/>
								</Col>
								<FormText color="danger">
									A Statement of Facts is required when selecting an out of
									state buyer dealer. By clicking Submit, you are confirming a
									completed Statement of Facts will be retained in the
									dealership records for this sale.
								</FormText>
							</FormGroup>
						</>
					)}
					{coBuyerRecNum && (
						<FormGroup check className="ml-0">
							<Label check>
								<Input
									type="checkbox"
									name="isAnd"
									checked={formData.isAnd}
									onChange={handleChange}
								/>
								<span style={{ marginLeft: "0.5rem" }}>
									Second owner listed on title as "AND"?
								</span>
							</Label>
						</FormGroup>
					)}

					<Button onClick={submitData}>Submit</Button>
				</Form>
			</ChildrenModal>
			<Row className="justify-content-center">-</Row>
			<Row className="justify-content-center">
				<div className="col-md-3">
					<DLRdmv />
				</div>
				<div className="col-md-3">
					<DMVdesk />
				</div>
				<div className="col-md-3">
					<VerifinyX />
				</div>
			</Row>
		</Col>
	);
};

FairFaxTab.propTypes = {
	ID: PropTypes.number,
	license: PropTypes.string,
	editVehicle: PropTypes.func,
	vehicle: PropTypes.object,
	locationID: PropTypes.string,
};

export default FairFaxTab;
